module.exports = __webpack_public_path__ + "static/media/credit-card-front.b1d6f2a3.svg";